{#each content.split('\n').filter(Boolean) as paragraph}

<p>

    {#each paragraph.split(pattern) as line}

    {#if line.match(pattern)}

    <a href={line}>{line}</a>

    {:else}

    {@html line}

    {/if}

    {/each}

</p>

{/each}

<script>
    export default {
        data() {
            return {
                pattern: /(https?:\/\/[a-zA-Z0-9\.\/\?\&\-]+)/,
                content: ''
            }
        }
    }
</script>